<template>
   <div class="first-level">
      
      <v-app-bar id="appBar"
         app
         shrink-on-scroll
         scroll-threshold="250"
         fixed
         min-height="45px"
         height="113px"
         dense
      >
         <v-app-bar-nav-icon @click="drawer = !drawer" left id="nav-button" />

         <v-row class="row-header" center>
            <v-col class="column-logo">
               <v-list-item
                  :to="`/${$i18n.locale}`" 
                  class="link-logo"
               >
                  <img src="@/assets/logo-paquetgrup-white.png" class="logo" :class="isActive">
               </v-list-item>
            </v-col>
            <v-col class="column-header" >
               <Header />
            </v-col>
         </v-row>

      </v-app-bar>

      <v-navigation-drawer
         class="navmenu grey darken-4"
         v-model="drawer" app
         fixed
         temporary
         dark
         overlay-opacity=".9"
         overlay-color="#264653"
         elevate-on-scroll
         >
         
        <menu-mobile />
     
      </v-navigation-drawer>
      <Footer />
   </div>
</template>

<script>
import MenuMobile from '@/components/menu/MenuMobile.vue'
import Footer from '@/components/Footer.vue'
import Header from '@/components/Header.vue'

export default {
   name: 'navigationDrawer',
   components: {
      Footer,
      Header,
      MenuMobile
   },
   data: () => ({
      drawer: false,
      isActive: "",
      post: {
         logoimage: {
            logowhite: "../../assets/packetgrup-logo-black.png",
            logoblack: "../../assets/packetgrup-logo-black-01.png"
         }
      }
   }),
   computed: {
      classObject: function () {
         return {
            active: this.isActive && !this.error,
            'text-danger': this.error && this.error.type === 'fatal'
         }
      },
   },
   methods: {
      stop: function () {
         event.$emit('drawer', this.drawer);
         console.log('drawer')
      },
      setLocale(locale){
   /*       state.language = locale; */
         this.$i18n.locale = locale
   /*       locale = state.language
         console.log(locale) */
   /*       console.log('setlocale')
         console.log(locale) */
   /*       console.log(language) */
         this.$router.push({
         path: `/${this.$i18n.locale}${this.$route.name}`,
   /*  name: 'Enfardadores', */
         params: { lang: locale }
         })
      },
   }
}
</script>

<style scoped lang="scss">

   .navmenu, .navmenu a {
      text-decoration: none !important;
   }

   .row-header {
      flex-flow: column;
   }

   #logo-packetgrup {
      padding-top: 3px;
   }
 

</style>
